import { createAction, props } from '@ngrx/store';
import { MedicalRecordNotification } from '../../models/medical-record-notification';

export const getMedicalRecordNotifications = createAction('[Medical Record] Get Medical Record Notifications');

export const getMedicalRecordNotificationsSuccess = createAction(
  '[Medical Record] Get Medical Record Notifications Success',
  props<{ notifications: MedicalRecordNotification }>()
);

export const getMedicalRecordNotificationsFailure = createAction(
  '[Medical Record] Get Medical Record Notifications Failure',
  props<{ error: unknown }>()
);
